import React from "react";

import {DropRangeCalendar} from "@ui/general/DropRangeCalendar";
import {RootIcon} from "@ui/icons/RootIcon";
import {RootCheckbox} from "@ui/inputs/RootCheckbox";
import {H3} from "@ui/titles/H3";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const Head = (props) => {
  const {
    title,
    checkboxLabel,
    updateCharts,
    setWithArchived = () => {},
    withArchived = false,
    chartsDate,
    minDate,
    setFromDate = () => {},
    setToDate = () => {},
    maxWidth = "985rem",
  } = props;

  const {isMobile} = useSelector((state) => state.common.settings);

  return (
    <div
      className={styles.chartsHead}
      style={{maxWidth}}
    >
      <div className={styles.chartsHeadTitle}>
        {isMobile && updateCharts && (
          <RootIcon
            onClickIcon={() => updateCharts()}
            id={"refresh-upload"}
          />
        )}

        <H3>{title}</H3>

        {checkboxLabel && (
          <RootCheckbox
            onChange={() => setWithArchived(!withArchived)}
            label={checkboxLabel}
            checked={withArchived}
          />
        )}
      </div>

      {minDate && chartsDate && setFromDate && setToDate && (
        <DropRangeCalendar
          monthYearOnly
          minDate={minDate}
          fromDate={chartsDate?.from}
          setFromDate={(date) => setFromDate(date)}
          toDate={chartsDate?.to}
          setToDate={(date) => setToDate(date)}
        />
      )}

      {!isMobile && updateCharts && (
        <RootIcon
          onClickIcon={() => updateCharts()}
          id={"refresh-upload"}
        />
      )}
    </div>
  );
};
